import { useState } from "react";
import { createPaymentSession } from "../endpoints/api";
import { loadStripe } from '@stripe/stripe-js';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
// console.log("stripe priomise", stripePromise)

const MidAttemptsModal = ({ userInfo, handleClose, recordClick }) => {

    const [clicked, setClicked] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleButtonClick = async (e, user) => {
        e.preventDefault()
        setClicked(true)
        recordClick(userInfo?.uuid || '', userInfo?.email || '')
        // console.log("Clicked on unlock!")
        setLoading(true)
        try {
            const resp = await createPaymentSession(user.uuid, user.email, 'LEGACY')
            // console.log("payment session", resp)
            if (resp && resp.data) {
                const sessionId = resp.data.sessionId
                if (!sessionId) {
                    throw new Error("Couldn't find checkout session")
                }
                // Redirect to Stripe Checkout
                const stripe = await stripePromise;
                const { error } = await stripe.redirectToCheckout({
                    sessionId
                });

                if (error) {
                    console.error('Stripe Checkout Error:', error);
                }
            } else {
                throw new Error("Couldn't create payment session")
            }
        } catch (error) {
            console.log('Error opening payment', error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div
            style={{ zIndex: 100, minHeight: "100vh" }}
            className="absolute inset-0 flex items-center justify-center bg-[#141A1E] bg-opacity-80"
        >
            <div className="w-[90%] md:w-[80%] md:max-w-[894px] flex flex-col items-center justify-center bg-mid-attempts-modal bg-cover rounded-[24px] px-4 md:px-6 py-8 md:py-12 text-white relative">
                <button className="absolute right-[10px] top-[5px] text-xl md:text-2xl flex justify-center items-center"
                    onClick={handleClose}
                >
                    &times;
                </button>
                <div className="w-[80%] md:w-[70%] font-inter font-medium text-[16px] md:text-[24px] text-center leading-[120%]">
                    {`15 Quizzes`}
                </div>
                <div className="w-[80%] md:w-[70%] font-inter font-medium text-[24px] md:text-[32px] text-center leading-[120%]">
                    {`Wow You're Unstoppable!`}
                </div>
                <div className="mt-6 w-[80%] md:w-[70%] font-inter text-[14px] md:text-[20px] text-center leading-[120%] opacity-60">
                    {`Keep Going`}
                </div>
                <div className="mt-6 w-[80%] md:w-[70%] font-inter text-[14px] md:text-[20px] text-center leading-[120%]">
                    {`You get 20 free daily plays, or unlock unlimited quizzes all month for a small fee to support us`}
                </div>
                <button
                    onClick={(e) => handleButtonClick(e, userInfo)}
                    className="mt-2 bg-[#060606] text-white text-[14px] md:text-[18px] font-bold py-2 px-4 md:px-6 rounded-[24px] border-[2px] border-[#FEC330] flex items-center justify-center"
                    disabled={clicked}
                >
                    {clicked ? `Loading...` : `Unlock Unlimited Now`}
                </button>
            </div>
        </div>
    );
};

export default MidAttemptsModal;
